<template>
    <div>
        <FormControl
            required
            label="Label"
        >
            <TextInput
                :value="localSettings?.data.singleCheckboxLabel"
                :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.SingleCheckbox}][${CustomFieldSettingsKeysEnum.SingleCheckbox_Label}]`"
                required
            />
        </FormControl>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import {
        CustomFieldSettingsKeysEnum,
        CustomFieldTypeEnum,
        type CustomFieldSettingsSingleCheckboxType,
    } from '@/Shared/AutoGenerated/Main'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField | null>,
            default: null,
        },
    })

    const localSettings: CustomFieldSettingsSingleCheckboxType | null =
        props.customField?.settings
</script>
